import _extends from "@babel/runtime/helpers/esm/extends";
var _circle, _path, _path2;
import React from 'react';
import { SvgIcon } from '@mui/material';
const Netherlands = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 512 512",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: "256",
  cy: "256",
  r: "256",
  fill: "#f0f0f0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M256 0C145.929 0 52.094 69.472 15.923 166.957h480.155C459.906 69.472 366.071 0 256 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M256 512c110.071 0 203.906-69.472 240.077-166.957H15.923C52.094 442.528 145.929 512 256 512z"
}))));
export default Netherlands;